import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import Avatar from '@gik/ui/Avatar';
import { useUserStore } from '@gik/core/store/UserStore';
import { useUser } from '@gik/api/users/user';

export interface IUserAvatarProps extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Displays the avatar of the currently logged in user.
 */
export default function UserAvatar({ className, ...otherProps }: IUserAvatarProps): React.ReactElement {
  const bem = bemBlock('user-avatar');

  const userStore = useUserStore();
  const { data: user, isValidating } = useUser(userStore.id);

  return (
    <Avatar loading={isValidating} imageUrl={user?.avatarThumbSmallURL} className={bem(null, null, className)} {...otherProps} />
  );
}
